import { Box, CircularProgress, Stack, Typography } from '@mui/material'

interface FullPageLoaderProps {
  label?: string
  /**
   * Center within the surrounding panel instead of the whole viewport. Use this
   * for fallbacks inside the app shell, where the top bar stays visible.
   */
  contained?: boolean
}

/**
 * Centered loading state for whole-page waits.
 *
 * Fills the viewport by default so the spinner sits in the true centre; pass
 * `contained` for a panel-sized loader inside the authenticated shell.
 */
export function FullPageLoader({ label = 'Loading…', contained = false }: FullPageLoaderProps) {
  return (
    <Stack
      spacing={2}
      sx={{
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: contained ? '60vh' : '100dvh',
        width: '100%',
      }}
      role="status"
      aria-live="polite"
    >
      <CircularProgress />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Stack>
  )
}

export function InlineLoader({ label = 'Loading…' }: { label?: string }) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5, py: 4, justifyContent: 'center' }}>
      <CircularProgress size={20} />
      <Typography variant="body2" color="text.secondary">
        {label}
      </Typography>
    </Box>
  )
}
